import React, { useEffect } from 'react'
import Aos from 'aos'
import 'aos/dist/aos.css'
import './signature.css'
import { Link } from 'react-router-dom'
import { HiOutlineLocationMarker } from 'react-icons/hi'
import img8 from '../../Assets/signImg/img8.jpeg'

// 行程資料陣列
const Data = [
  {
    id: 8,
    imgSrc: img8,
    destTitle: '行者無疆 - 250年的美國獨立之路',
    location: '🇺🇸 · 美國 · 東岸',
    company: '美國 · 跨文化體驗',
    grade: '14-23',
    fees: '2990 美元',
    description:
      '從五月花號到南北戰爭，從權力之心到紐約天際線，美國東岸見證了建國與發展的歷程。踏上美國人最熱愛的「Hit the Road」公路旅行，穿越建國獨立、奴隸逃亡與都市繁華的歷史足跡。2025年，更將特別前往華盛頓，親歷美國獨立戰爭250週年紀念慶典。'
  }
]

export default function Signature8() {
  // 初始化動畫效果
  useEffect(() => {
    Aos.init({ duration: 2000 })
  }, [])

  return (
    <section className='signMain signContainer signSection'>
      <div className='signSecTitle'>
        <h3 data-aos='fade-right' className='signTitle'>
          行 者 無 疆 - 250 年 的 美 國 獨 立 之 路
        </h3>
        <button className='signHomeBtn'>
          <Link to={'/'} className='signHomeBtnLink'>返回首頁</Link>
        </button>
      </div>

      <div className='signSecContent signGrid'>
        {Data.map(({ id, imgSrc, destTitle, location, company, fees, description }) => (
          <div key={id} data-aos='fade-up' className='signSingleDestination'>
            <div className='signCardInfo'>
              <h4 className='signDestTitle'>{destTitle}</h4>
              <span className='signContinent signFlex'>
                <HiOutlineLocationMarker className='icon' />
                <span className='signName'>{location}</span>
              </span>

              <div className='signFees signFlex'>
                <div className='signGrade'>
                  <span>
                    執行機構：{company}
                    <br /><br />
                    <small>⭐️ 行 程 精 華 ⭐️</small>
                    <br /><br />
                  </span>
                </div>
                <div>
                  <h6>{description}</h6>
                  <br />

                  <table width='90%'>
                    <tbody>
                      <tr>
                        <td>活動亮點</td>
                        <td></td>
                        <td>
                          美國250年獨立紀念日歡樂大遊行；<br />
                          華盛頓美國國家博物館群落；<br />
                          美國國家機構；<br />
                          美國的重要歷史事件；<br />
                          自由與繁榮的象徵；
                        </td>
                      </tr>
                      <tr>
                        <td>沉浸式體驗</td>
                        <td></td>
                        <td>體驗美國獨立、自由、繁榮之路上重要的節點；</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='signFees signFlex'>
                <div className='signGrade'>
                  <span>
                    <small>⭐️ 參 團 資 訊 ⭐️</small>
                  </span>
                  <br /><br />
                </div>
                <table width='100%'>
                  <tbody>
                    <tr><td>參團年齡</td><td></td><td>14-18歲學生</td></tr>
                    <tr><td>適合人群</td><td></td><td>感興趣美國的歷史和文化，喜歡公路旅行</td></tr>
                    <tr><td>時間安排</td><td></td><td>7月（為期12天）</td></tr>
                    <tr><td>地點</td><td></td><td>美國 · 東海岸</td></tr>
                    <tr><td>費用包含</td><td></td><td>正餐、住宿、交通、門票</td></tr>
                    <tr><td>費用不包含</td><td></td><td>簽證、機票、保險、個人消費</td></tr>
                  </tbody>
                </table>
              </div>

              <div className='signFees'>
                <div className='signGrade'>
                  <span>
                    <small>⭐️ 參 考 行 程 ⭐️</small>
                  </span>
                  <br /><br />
                </div>
                <h6>行程範例</h6>
                <p>實際活動內容可能會有前後調整，或被相近內容替代；行程將於出發前四週確認。</p>

                <table width='100%'>
                  <thead>
                    <tr>
                      <th>日期</th>
                      <th>上午活動</th>
                      <th>下午活動</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>第一日</td><td>出發</td><td>抵達華盛頓休息</td></tr>
                    <tr><td>第二日</td><td>自然歷史博物館</td><td>航天博物館 / 國家美術館</td></tr>
                    <tr><td>第三日</td><td>美國獨立日慶典</td><td>白宮 / 紀念堂 / 焰火</td></tr>
                    <tr><td>第四日</td><td>國會山 / 財政部</td><td>五角大廈 / 阿靈頓</td></tr>
                    <tr><td>第五日</td><td>戰場參訪</td><td>抵達費城</td></tr>
                    <tr><td>第六日</td><td>葛底斯堡</td><td>獨立公園 / 自由鐘</td></tr>
                    <tr><td>第七日</td><td>自由女神像</td><td>華爾街 / 市政廳</td></tr>
                    <tr><td>第八日</td><td>航母博物館</td><td>大都會博物館 / 百老匯</td></tr>
                    <tr><td>第九日</td><td>西點軍校</td><td>Outlet 購物</td></tr>
                    <tr><td>第十日</td><td>普林斯頓</td><td>耶魯大學</td></tr>
                    <tr><td>第十一日</td><td>戰場參訪</td><td>波士頓自由之路</td></tr>
                    <tr><td>第十二日</td><td>返程</td><td>順利回家</td></tr>
                  </tbody>
                </table>

                <div className='signGrade'>
                  <span>
                    <small>⭐️ 課 程 和 活 動 說 明 ⭐️</small>
                  </span>
                  <br /><br />
                </div>
                <p>
                  <b>博物館群落：</b> 航天、自然歷史、美術館、歷史館、圖書館、間諜館；<br />
                  <b>國家機構：</b> 五角大廈、國會山、白宮；<br />
                  <b>歷史足跡：</b> 阿靈頓公墓、林肯遇刺劇院、獨立公園、戰場、波士頓自由之路；<br />
                  <b>自由象徵：</b> 自由女神像、911紀念館、百老匯、哥大、哈佛、西點等。
                </p>
              </div>

              <div className='signPrice'>
                <h5>預售價格：{fees}</h5>
              </div>
              <Link to={"/formReg"} target="_blank">
              <button className='signBtn signFees'>
                <h4>⭐️ ⭐️ ⭐️ 預 約 報 名 - 搶 先 卡 位 ⭐️ ⭐️ ⭐️</h4>
              </button>
              </Link>
            </div>

            <div className='signImageDiv'>
              <img src={imgSrc} alt={destTitle} />
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}